/**
 * Android's system photo picker returns at most 100 photos per pick
 * (MediaStore.getPickImagesMaxLimit() on stock Android). Chrome uses that
 * picker for our image-only file input, so a customer choosing 300 photos
 * silently gets 100.
 *
 * In the prod DB, Android web groups of EXACTLY 100 photos are 40-60x as
 * common as 99 or 101, and customers work around it by creating a new cart
 * item per 100. Picking again before uploading already appends to the same
 * item; nothing told them so.
 */
export const ANDROID_PICK_LIMIT = 100;

export function isAndroid(userAgent?: string): boolean {
  const ua =
    typeof userAgent === "string"
      ? userAgent
      : typeof navigator === "undefined"
        ? ""
        : navigator.userAgent;
  return /\bAndroid\b/i.test(ua);
}

/** True when this pick looks like it was cut off by Android's cap. */
export function hitAndroidPickLimit(pickedCount: number, userAgent?: string): boolean {
  return pickedCount === ANDROID_PICK_LIMIT && isAndroid(userAgent);
}
